<!--
 * @Description: 电站运维报表
-->
<template>
  <scroll-layout class="station-ops-report">
    <template slot="header">
      <ykc-search
        ref="YkcSearch"
        :data="searchData"
        :searchForm="searchParams"
        @clean="handleSearchClean"
        @click="handleSearchConfirm"></ykc-search>
    </template>
    <ykc-table ref="YkcTable" :data="tableData" title="电站运维报表" :columns="tableColumns">
      <template #headerButtons>
        <div class="table-header-button">
          <ykc-button v-rbac="'operation:stationReport:export'" type="plain" @click="doExportFile">
            导出
          </ykc-button>
        </div>
      </template>

      <ykc-pagination
        align="right"
        slot="pagination"
        ref="YkcPagination"
        :total="pageInfo.total"
        :page-size.sync="pageInfo.size"
        :current-page.sync="pageInfo.current"
        @size-change="handlePaginationSizeChange"
        @current-change="handlePaginationCurrentChange"></ykc-pagination>
    </ykc-table>
  </scroll-layout>
</template>

<script>
  import { stationReportApi } from '@/service/apis';
  import { offlineExport } from '@/utils';

  export default {
    name: 'StationOpsReport',
    data() {
      return {
        tableData: [],
        pageInfo: {
          current: 1,
          size: 10,
          total: 0,
        },
        searchParams: {
          platform: '',
          stationName: '',
          stationType: '',
          assigneeName: '',
          startDate: '',
          endDate: '',
        },
        addressData: [],
      };
    },
    computed: {
      searchData() {
        return [
          {
            comName: 'YkcDropdown',
            key: 'platform',
            label: '所属平台',
            placeholder: '请选择所属平台',
            data: [
              { id: '', name: '全部' },
              { id: 2, name: '益虫' },
              { id: 1, name: '淘淘充' },
            ],
          },
          {
            comName: 'YkcInput',
            key: 'stationName',
            label: '电站名称',
            placeholder: '请输入电站名称',
          },
          {
            comName: 'YkcDropdown',
            key: 'stationType',
            label: '电站类型',
            placeholder: '请选择电站类型',
            data: [
              { id: '', name: '全部' },
              { id: 1, name: '公桩' },
              { id: 2, name: '私桩' },
            ],
          },
          {
            comName: 'YkcInput',
            key: 'assigneeName',
            label: '运维负责人',
            placeholder: '请输入运维负责人',
          },
          {
            comName: 'YkcDatePicker',
            key: 'dateRange',
            label: '时间周期',
            startPlaceholder: '开始日期',
            endPlaceholder: '结束日期',
            type: 'daterange',
            valueFormat: 'yyyy-MM-dd',
          },
        ];
      },
      tableColumns() {
        return [
          { label: '电站名称', prop: 'stationName', minWidth: '180px' },
          { label: '所属平台', prop: 'platformText', minWidth: '90px' },
          {
            label: '电站类型',
            prop: 'stationTypeText',
            minWidth: '100px',
            formatter: row => {
              if (row.stationType === 1) return '公桩';
              if (row.stationType === 2) return '私桩';
              return '——';
            },
          },
          { label: '运维负责人', prop: 'assigneeName', minWidth: '120px' },
          {
            label: '设备故障次数',
            prop: 'faultCount',
            minWidth: '120px',
            align: 'center',
            formatter: row => {
              const count = row.faultCount || 0;
              return count > 0
                ? `<span style="color:#e53e3e;font-weight:500">${count}</span>`
                : count;
            },
          },
          {
            label: '设备离线次数',
            prop: 'offlineCount',
            minWidth: '120px',
            align: 'center',
            formatter: row => {
              const count = row.offlineCount || 0;
              return count > 0
                ? `<span style="color:#dd6b20;font-weight:500">${count}</span>`
                : count;
            },
          },
          { label: '维修工单数量', prop: 'orderCount', minWidth: '120px', align: 'center' },
          {
            label: '工单完成数量',
            prop: 'completedOrderCount',
            minWidth: '120px',
            align: 'center',
            formatter: row => {
              const count = row.completedOrderCount || 0;
              return count > 0
                ? `<span style="color:#38a169;font-weight:500">${count}</span>`
                : count;
            },
          },
          { label: '巡检次数', prop: 'inspectionCount', minWidth: '100px', align: 'center' },
        ];
      },
    },
    created() {
      this.requestList();
    },
    methods: {
      /** 查询列表 */
      requestList() {
        const params = {
          ...this.searchParams,
          pageNum: this.pageInfo.current,
          pageSize: this.pageInfo.size,
        };
        stationReportApi.getList(params).then(res => {
          /* eslint-disable prefer-destructuring */
          this.tableData = (res && res.records) || [];
          this.pageInfo.total = (res && res.total) || 0;
          /* eslint-enable prefer-destructuring */
        });
      },
      /** 搜索确认 */
      handleSearchConfirm(data) {
        if (data && data.dateRange && data.dateRange.length === 2) {
          this.searchParams.startDate = data.dateRange[0];
          this.searchParams.endDate = data.dateRange[1];
        } else {
          this.searchParams.startDate = '';
          this.searchParams.endDate = '';
        }
        this.searchParams.stationName = (data && data.stationName) || '';
        this.searchParams.stationType = (data && data.stationType) || '';
        this.searchParams.platform = (data && data.platform) || '';
        this.searchParams.assigneeName = (data && data.assigneeName) || '';
        this.pageInfo.current = 1;
        this.requestList();
      },
      /** 搜索重置 */
      handleSearchClean() {
        this.searchParams = {
          platform: '',
          stationName: '',
          stationType: '',
          assigneeName: '',
          startDate: '',
          endDate: '',
        };
        this.pageInfo.current = 1;
        this.requestList();
      },
      /** 分页 */
      handlePaginationCurrentChange(current) {
        this.pageInfo.current = current;
        this.requestList();
      },
      handlePaginationSizeChange(size) {
        this.pageInfo.size = size;
        this.pageInfo.current = 1;
        this.requestList();
      },
      /** 导出 */
      doExportFile() {
        offlineExport(
          {
            downloadType: 'station_ops_report_export',
            jsonNode: {
              ...this.searchParams,
            },
          },
          this.pageInfo.total
        );
      },
    },
  };
</script>
